<template>
  <div>SLO LOGIN PAGE</div>
</template>

<script>
export default {
  props: ['userNo'],
  data() {
    return {
      loginInfo: {
        loginId: '',
        loginPw: '',
        compCd: '',
        loginDeptNm: '',
        loginDeptCd: '',
        loginDutCd: '',
        loginDutNm: '',
        loginJobCd: '',
        loginJobNm: '',
        token: '',
        menu: [],
        authorities: [],
      },
    }
  },
  mounted() {
    this.socialLogin();
  },
  methods: {
    async socialLogin(){
      console.log(this.$route.path.substring(5))

      const loginId = this.$route.path.substring(5);
      this.loginInfo.loginId = loginId;

      if(!loginId) {
        this.$message({showClose: true, type: 'warning', message: `비정상 접근입니다.`});
        //this.$router.push({path: '/'});
        location.replace('/')
      } else {
        try {
          this.$store.commit('loading');
          const response = await this.$http.post('/api/login/slo', this.loginInfo);
          const loginInfo = {};
          console.log('loginInfo')
          console.log(response)
          loginInfo.userName = response.data.userName;
          loginInfo.loginId = response.data.loginId;
          loginInfo.compCd = response.data.loginCompCd;
          loginInfo.loginDeptNm = response.data.loginDeptNm;
          loginInfo.loginDeptCd = response.data.loginDeptCd;
          loginInfo.loginDutCd = response.data.loginDutCd;
          loginInfo.loginDutNm = response.data.loginDutNm;
          loginInfo.loginJobCd = response.data.loginJobCd;
          loginInfo.loginJobNm = response.data.loginJobNm;
          loginInfo.token = response.data.token;
          loginInfo.menu = response.data.menu;
          loginInfo.authorities = response.data.authorities;
          loginInfo.loginPw = 'Not Use';

          this.$store.commit('login', loginInfo);
          this.$cookie.set('loginInfo', JSON.stringify(loginInfo));
          //this.$cookie.set('sessionAlive', true);
          this.$http.defaults.headers['x-auth-token'] = loginInfo.token;
          console.log('loginInfo')
          console.log(response.data)
          this.$store.commit('finish');
        } catch(err) {
          this.$store.commit('finish');
          this.loginFail();
        } finally {
          setTimeout(() => {
            this.$store.commit('finish');
            this.$router.push({path: `/backOffice`});
          }, 500)

        }
      }
    }
  }

}
</script>